import { computed, ref, h } from 'vue';
import useFacetUrl from '@components/FilteringFacets/composables/useFacetUrl';

const brandSearch = ref('');

export default function useBrandFacet(props) {
  /* istanbul ignore else */
  if (!props.keepSearchValue) {
    brandSearch.value = '';
  }

  const { generateFacetUrl } = useFacetUrl();

  const filteringString = computed(() => brandSearch.value.replace(/[^\w. &-]+/g, ''));

  function customValueRenderer(value) {
    let renderedValue = {
      label: value.label,
      ariaLabel: value.label,
      value: value.value,
      count: value.count,
      labelType: 'html',
      url: props.renderDuringSsr ? generateFacetUrl(value.url) : value.url,
    };
    // render only the values that correspond to the filter
    const search = filteringString.value;
    /* istanbul ignore else */
    if (search.length) {
      if (value.label.toUpperCase().includes(search.toUpperCase())) {
      // should filter 'Br[anD]', 'br[and]', 'bR[ANd]' when the search string is 'and'
        const valueText = value.label.toUpperCase();
        const searchText = search.toUpperCase();
        const searchTextIndex = valueText.indexOf(searchText);
        const sliceText = value.label.slice(searchTextIndex, searchText.length + searchTextIndex);
        const labelHighlighted = h('span', { innerHTML: value.label.split(sliceText).join(`<strong>${sliceText}</strong>`) });
        renderedValue.label = h('span', labelHighlighted);
      } else renderedValue = '';
    }
    return renderedValue;
  }

  function clearBrandSearch() {
    brandSearch.value = '';
  }

  return {
    filteringString,
    brandSearch,
    customValueRenderer,
    clearBrandSearch,
  };
}
